'use client';

import React from 'react';
import { ContactForm } from '@workspace/widgets';

export type ContactFormBlockData = {
  _type: string;
  _key: string;
  /** Optional heading displayed above the form. */
  heading?: string;
  /**
   * HubSpot form ID. Leave blank to use the default contact form.
   */
  formId?: string;
  /** Custom thank-you message shown after successful submission. Sourced from Sanity. */
  thankYouMessage?: string;
};

export function ContactFormBlock({ block }: { block: ContactFormBlockData }) {
  return (
    <div className="wrapper mx-auto px-md lg:px-full-banner py-lg lg:py-2xl">
      <ContactForm heading={block.heading} formId={block.formId} thankYouMessage={block.thankYouMessage} />
    </div>
  );
}
